var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1749 56.875L56.2143 47.5M46.7857 47.5L35.8251 56.875M35 39.6875L48.4721 48.6179C49.563 49.341 50.1085 49.7026 50.7018 49.8427C51.2259 49.9664 51.7741 49.9664 52.2982 49.8427C52.8915 49.7026 53.4369 49.341 54.5279 48.6179L68 39.6875M42.92 60H60.08C62.8523 60 64.2384 60 65.2973 59.4891C66.2287 59.0397 66.9859 58.3226 67.4605 57.4406C68 56.4379 68 55.1252 68 52.5V42.5C68 39.8748 68 38.5621 67.4605 37.5594C66.9859 36.6774 66.2287 35.9603 65.2973 35.5109C64.2384 35 62.8523 35 60.08 35H42.92C40.1477 35 38.7616 35 37.7027 35.5109C36.7713 35.9603 36.0141 36.6774 35.5395 37.5594C35 38.5621 35 39.8748 35 42.5V52.5C35 55.1252 35 56.4379 35.5395 57.4406C36.0141 58.3226 36.7713 59.0397 37.7027 59.4891C38.7616 60 40.1477 60 42.92 60Z",
    stroke: "#5D62B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 47.5C99 73.7335 77.7335 95 51.5 95C25.2665 95 4 73.7335 4 47.5C4 21.2665 25.2665 0 51.5 0C77.7335 0 99 21.2665 99 47.5ZM7.77881 47.5C7.77881 71.6465 27.3535 91.2212 51.5 91.2212C75.6465 91.2212 95.2212 71.6465 95.2212 47.5C95.2212 23.3535 75.6465 3.77881 51.5 3.77881C27.3535 3.77881 7.77881 23.3535 7.77881 47.5Z",
    fill: "#5D62B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9c1c21b18ae2cdbdde40744569bf713a.svg";
export { ForwardRef as ReactComponent };